// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import FlexWrapContainer from "@insite/content-library/Widgets/Brand/FlexWrapContainer";
import { IconWrapper } from "@insite/mobius/Icon";
import cartLineSharedStyles from "@pace/App/SharedStyles/CartLineSharedStyles";
import { cartLineCardExpandedStyles } from "@pace/Overrides/Widgets/Cart/CartLineCardExpanded";
import { mergeWithCss, sharedBadgeStyle, xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

cartLineCardExpandedStyles.productImage = {
    ...cartLineSharedStyles.productImage,
};

cartLineCardExpandedStyles.productDescription = {
    ...cartLineSharedStyles.productDescription,
};

cartLineCardExpandedStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
};

cartLineCardExpandedStyles.productPrice = {
    ...cartLineSharedStyles.productPrice,
};

cartLineCardExpandedStyles.extendedUnitNetPriceHeadingAndText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};

cartLineCardExpandedStyles.removeCartLineIcon = {
    ...cartLineSharedStyles.removeCartLineIcon,
};

cartLineCardExpandedStyles.addToListLink = {
    ...cartLineSharedStyles.addToListLink,
};

cartLineCardExpandedStyles.configurationOptionText = {
    css: css`
        display: block;
    `,
};

cartLineCardExpandedStyles.deliveryScheduleButton = {
    css: css`
        margin-bottom: 10px;
    `,
};

cartLineCardExpandedStyles.configurationGridItem = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

cartLineCardExpandedStyles.promotionNameText = {
    ...cartLineSharedStyles.promotionNameText,
};

cartLineCardExpandedStyles.costCodeText = {
    ...cartLineSharedStyles.costCodeValueText,
};

cartLineCardExpandedStyles.productAvailability = {
    ...cartLineSharedStyles.productAvailability,
};

cartLineCardExpandedStyles.cartLineNotes = {
    ...cartLineSharedStyles.cartLineNotes,
};

cartLineCardExpandedStyles.extendedProductImageBadges = {
    container: {
        css: css`
            flex: auto;
            ${FlexWrapContainer} {
                gap: 4px;
                flex: 1;
                justify-content: start;
            }
        `,
    },
    image: {
        css: css`
            width: 14px;
            height: 14px;
        `,
    },
    imageItem: {
        css: css`
            flex: 1;
            padding: 0;
            width: 24px;
            max-width: 24px;
            height: 24px;
        `,
    },
};

cartLineCardExpandedStyles.extendedUnitNetPriceWrapper = {
    css: css`
        display: flex;
        align-items: center;
        ${xScreen("lt", "sm")} {
            align-items: end;
        }
    `,
};

cartLineCardExpandedStyles.specialOrderTooltip = {
    cssOverrides: {
        tooltipClickable: css`
            margin-left: 4px;
        `,
    },
};

cartLineCardExpandedStyles.specialOrderIcon = {
    size: 14,
    color: "common.ui10",
    css: css`
        opacity: 0.5;
    `,
};

cartLineCardExpandedStyles.costCodeSelect = {
    cssOverrides: {
        formField: css`
            width: 200px;
        `,
    },
};

cartLineCardExpandedStyles.badgeAreaWrapper = {
    css: css`
        position: relative;
    `,
};

cartLineCardExpandedStyles.badgeContainer = {
    ...mergeWithCss(sharedBadgeStyle.badge, {
        css: css`
            right: -8px;
            & ${IconWrapper} {
                opacity: 0.66;
            }
        `,
    }),
};
// XNG-Changes:PAC-953
cartLineCardExpandedStyles.cartLineErrorMessageGridItem = {
    width: 12,
    css: css`
        margin-top: 16px;
    `,
};

cartLineCardExpandedStyles.quantity = {
    editableQuantityTextField: {
        qtyLabel: {
            css: css`
                ${xScreen("gt", "lg")} {
                    display: none;
                }
            `,
        },
    },
};
